export interface CommunityEvent {
  /** Event title as it should appear on the card */
  title: string
  titleEs?: string
  /** Hosting organization */
  organization: string
  /** City and state, e.g. 'Miami, FL' */
  city: string
  /**
   * Machine-readable event date, 'YYYY-MM-DD'.
   * REQUIRED — the scroller sorts by this so events always display in
   * chronological order regardless of the order they are written here.
   */
  startDate: string
  /** Human-readable date shown on the card, e.g. 'Tuesday, October 6' */
  date: string
  dateEs?: string
  /** Flyer, photo, or graphic for the event (full URL) */
  image: string
  /** Optional registration or info link */
  url?: string
}

/**
 * Upcoming events hosted by the Association and partner organizations.
 *
 * These scroll continuously in the band above the consular help section on
 * the homepage.
 *
 * RULE: every entry must include `startDate` in 'YYYY-MM-DD' form. New events
 * can be appended anywhere in this list — `UPCOMING_EVENTS` sorts them into
 * chronological order (soonest first) automatically, so there is no need to
 * insert them by hand in the right place.
 */
const EVENTS: CommunityEvent[] = [
  {
    title: 'Voices of Impact',
    titleEs: 'Voces de Impacto',
    organization: 'Honduran-American Association',
    city: 'New York, NY',
    startDate: '2026-10-01',
    date: 'Thursday, October 1',
    dateEs: 'Jueves 1 de Octubre',
    image:
      'https://cdn.magicpatterns.com/uploads/fdgKGqY2axfX3n3ihCbwUD/Voices_of_Impact_-_New_York.jpg',
  },
  {
    title: 'Encuentro Catracho',
    organization: 'Honduran-American Association',
    city: 'Doral, FL',
    startDate: '2026-09-15',
    date: 'Tuesday, September 15',
    dateEs: 'Martes 15 de Septiembre',
    image:
      'https://cdn.magicpatterns.com/uploads/hNncZZyyQBicW536oFFq4C/Encuentro_Catracho_Miami.png',
    url: '#/encuentro-catracho-miami',
  },
  {
    title: 'Miss Fiesta DC 2026 — Alexandra Martínez, Miss Honduras DMV',
    titleEs: 'Miss Fiesta DC 2026 — Alexandra Martínez, Miss Honduras DMV',
    organization: 'Miss Fiesta DC · Lincoln Theater',
    city: 'Washington, D.C.',
    startDate: '2026-09-24',
    date: 'Thursday, September 24 · Doors 5 PM',
    dateEs: 'Jueves 24 de Septiembre · Puertas 5 PM',
    image:
      'https://cdn.magicpatterns.com/uploads/oLBK6d9GkFfF95i37ud8PZ/PHOTO-2026-09-07-19-57-20.jpg',
  },
  {
    title: 'Parrillada con Familia',
    organization: 'Hondurans in LA',
    city: 'Huntington Park, CA',
    startDate: '2026-09-27',
    date: 'Sunday, September 27 · 12–4 PM',
    dateEs: 'Domingo 27 de Septiembre · 12–4 PM',
    image:
      'https://cdn.magicpatterns.com/uploads/xsBqVKGLEjTgEogWABCGTo/Screenshot_2026-09-07_at_10.26.14_PM.png',
    url: 'https://partiful.com/e/8Cp4cpYUyeePXix6yLb9',
  },
  {
    title: 'Celebration of Stories 2026 — Love, Honduras',
    titleEs: 'Celebración de Historias 2026 — Amor, Honduras',
    organization: 'Association for a More Just Society (ASJ)',
    city: 'Denver, CO',
    startDate: '2026-10-06',
    date: 'Tuesday, October 6',
    dateEs: 'Martes 6 de Octubre',
    image:
      'https://cdn.magicpatterns.com/uploads/1wePiHW7ZsVY94y1VQgBbh/landing_page.png',
    url: 'https://lp.constantcontactpages.com/cu/yjwgaoS',
  },
  {
    title: 'Celebration of Stories 2026 — Love, Honduras',
    titleEs: 'Celebración de Historias 2026 — Amor, Honduras',
    organization: 'Association for a More Just Society (ASJ)',
    city: 'Arlington, VA',
    startDate: '2026-10-08',
    date: 'Thursday, October 8',
    dateEs: 'Jueves 8 de Octubre',
    image:
      'https://cdn.magicpatterns.com/uploads/oTZMfCUr2YKrsQzY8zNAnM/Arlington_event.png',
    url: 'https://lp.constantcontactpages.com/cu/pDx8tyW',
  },
  {
    title: 'Honduran Independence Day Celebration',
    titleEs: 'Celebración de la Independencia de Honduras',
    organization: 'Honduran-American Association',
    city: 'Washington, D.C.',
    startDate: '2026-09-15',
    date: 'Tuesday, September 15',
    dateEs: 'Martes 15 de Septiembre',
    image:
      'https://cdn.magicpatterns.com/uploads/ewJpinVHQ8s4RJSdCh5B3M/HAA_Sep_15.png',
    url: '#/independence-day',
  },
]

/** Events in chronological order — soonest first. */
export const COMMUNITY_EVENTS: CommunityEvent[] = [...EVENTS].sort((a, b) =>
  a.startDate.localeCompare(b.startDate),
)
